import React from "react";

import Layout from "../../components/Layout";
import ContentPage from "../../components/ContentPage";

import data from "./content.json";

const Privacy = () => {
    const { content } = data;
    return (
        <Layout>
            <ContentPage content={content} />
        </Layout>
    );
};

export default Privacy;
